import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { ButtonGroup } from '@/components/Button/ButtonGroup/ButtonGroup';
import { Button } from '@/components/Button/Button';
import { useNavigate } from 'react-router';
import { getAcceptMasterServiceAgreementPath } from '@/bundle/Auth/AdminOnboardingFlow/AcceptMasterServiceAgreementPage/path';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';

type DashboardTrialModeModalType = {
  isOpen: boolean;
  onClose: () => void;
};

export const DashboardTrialModeModal = ({ isOpen, onClose }: DashboardTrialModeModalType) => {
  const navigate = useNavigate();

  return (
    <ModalWindow isOpen={isOpen} headerText='Welcome to Your Dashboard' width='520px'>
      <Box display='flex' flexDirection='column' rowGap='28px'>
        <Box display='flex' flexDirection='column' rowGap='20px' alignItems='center'>
          <Typography>
            You are currently in <b>Trial Mode</b>, where you can explore the platform, input your receiving account
            info, and create transactions.
          </Typography>
          <Typography>Trial accounts are restricted from securely sharing or collecting wire instructions.</Typography>
          <Typography>Upgrade to a paid subscription to unlock full platform access.</Typography>
        </Box>
        <ButtonGroup mobileStretch gridTemplateColumns='0.4fr 0.6fr'>
          <Box display='flex' textAlign='center' alignItems='center'>
            <NavigationLink onClick={onClose} to='' size='large' width='100%'>
              Close
            </NavigationLink>{' '}
          </Box>
          <Button onClick={() => navigate(getAcceptMasterServiceAgreementPath())} autoFocus>
            Activate Subscription
          </Button>
        </ButtonGroup>
      </Box>
    </ModalWindow>
  );
};
